import { atom } from "recoil";

export const DataTypeOwnerState = atom({
  key: "DataTypeOwnerState",
  default: [],
});
